import { styled } from '@withjoy/joykit/theme';
import { animationTransition } from '../../utils/animationTransitions';
import { animated } from 'react-spring';
import type { SegmentedControllerVariant } from './SegmentedController.types';

export const ItemsWrapper = styled.div<Readonly<{ variant?: SegmentedControllerVariant }>>`
  min-height: ${({ variant }) => (variant === 'underline' ? '48px' : '44px')};
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: ${({ variant }) => (variant === 'underline' ? '0' : '4px')};
  position: relative;
  z-index: 1;
  width: 100%;
`;

export const PillIndicator = styled(animated.span)`
  position: absolute;
  bottom: 0;
  height: calc(100% - 8px);
  transition: ${animationTransition('background-color')};
  left: 0;
  width: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  z-index: 0;
  top: 50%;
`;

export const UnderlineIndicator = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  background-color: ${({ theme }) => theme.colors.mono14};
  border-radius: 2px;
  transition: ${animationTransition('transform', 'width', { duration: '300ms', timingFunction: 'ease' })};
  pointer-events: none;
`;

export const SegmentedControllerRoot = styled.div<Readonly<{ width?: string; isMobile?: boolean; variant?: SegmentedControllerVariant }>>`
  width: ${({ width, isMobile }) => (width && !isMobile ? width : isMobile ? '100%' : 'initial')};
  position: relative;
  background: ${({ variant, theme }) => (variant === 'underline' ? 'transparent' : theme.colors.mono2)};
  border-radius: ${({ variant }) => (variant === 'underline' ? '0' : '12px')};
  ${({ variant, theme }) => (variant === 'underline' ? `border-bottom: 1px solid ${theme.colors.mono3};` : '')}
`;
